export const isMobile = () => {
  const UA = typeof navigator === "undefined" ? "" : navigator.userAgent;
  return /mobi/i.test(UA);
};
export const isIOS = () => {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
};
